import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Chip, Avatar } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';

const ServicesTableRow = ({
    service,
    index,
    perms,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    page,
    perPage,
    isArabic,
}) => {
    const isSelected = selectedIds.includes(service.id);

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, service.id)}
                />
            </TableCell>

            {/* S/N */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {(page - 1) * perPage + index + 1}
            </TableCell>

            {/* العنوان */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ fontWeight: 500 }}>
                {isArabic
                    ? (service?.title?.ar || service?.title?.en || (typeof service?.title === 'string' ? service.title : '-'))
                    : (service?.title?.en || service?.title?.ar || (typeof service?.title === 'string' ? service.title : '-'))
                }
            </TableCell>

            {/* الصورة */}
            <TableCell align="center">
                {service?.image ? (
                    <Avatar
                        src={service.image}
                        alt="Service"
                        sx={{ width: 40, height: 40 }}
                    />
                ) : (
                    <Chip label={isArabic ? "لا توجد صورة" : "No Image"} size="small" variant="outlined" />
                )}
            </TableCell>

            {/* Slug */}
            {/* <TableCell align={isArabic ? 'right' : 'left'}>
                {service?.slug
                    ? <Chip label={service.slug} size="small" variant="outlined" sx={{ borderRadius: '6px', fontWeight: 'bold', fontFamily: 'monospace' }} />
                    : '-'
                }
            </TableCell> */}

            {/* الحالة */}
            <TableCell align="center">
                <Chip
                    label={service?.show_in_home ? (isArabic ? 'معروض' : 'Yes') : (isArabic ? 'مخفي' : 'No')}
                    size="small"
                    color={service?.show_in_home ? 'success' : 'default'}
                    variant="outlined"
                    sx={{ borderRadius: '6px' }}
                />
            </TableCell>

            {/* تاريخ الإضافة */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ whiteSpace: 'nowrap' }}>
                {service?.created_at ? dayjs(service.created_at).format('YYYY-MM-DD') : '-'}
            </TableCell>

            {/* الإجراءات */}
            <TableCell align="center">
                <IconButton onClick={(event) => onMenuOpen(event, service)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default ServicesTableRow;